import { supabase } from './supabase';

/**
 * Enhanced authFetch that automatically handles token refresh.
 * If the token is expired, it will try to refresh the session before making the request.
 */
export async function authFetch(url: string, options: RequestInit = {}): Promise<Response> {
  // Get current session
  let { data: { session } } = await supabase.auth.getSession();
  
  // If no session or token might be expired, try to refresh
  if (!session?.access_token) {
    console.log('[authFetch] No session found, attempting refresh...');
    const { data: refreshData, error: refreshError } = await supabase.auth.refreshSession();
    
    if (refreshError) {
      console.error('[authFetch] Session refresh failed:', refreshError);
      // Redirect to login if refresh fails
      if (typeof window !== 'undefined') {
        window.location.href = '/login?error=session_expired';
      }
      throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
    }
    
    session = refreshData.session;
  }
  
  const headers = new Headers(options.headers);
  if (session?.access_token) {
    headers.set('Authorization', `Bearer ${session.access_token}`);
  }
  
  const response = await fetch(url, { ...options, headers });
  
  // If we get a 401, try to refresh the token and retry once
  if (response.status === 401) {
    console.log('[authFetch] Got 401, attempting token refresh...');
    const { data: refreshData, error: refreshError } = await supabase.auth.refreshSession();
    
    if (refreshError || !refreshData.session) {
      console.error('[authFetch] Token refresh failed:', refreshError);
      if (typeof window !== 'undefined') {
        window.location.href = '/login?error=session_expired';
      }
      throw new Error('Sesión expirada. Por favor, inicia sesión nuevamente.');
    }
    
    // Retry the request with the new token
    headers.set('Authorization', `Bearer ${refreshData.session.access_token}`);
    return fetch(url, { ...options, headers });
  }
  
  return response;
}
